export default {"src":"/_next/static/media/zalo-icon.88ce0de7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};